import { Definition, UnknownSpec } from './definitions';
import { ContextLinkDefinition } from './links';
import { QueryDefinition } from './query';
import { FormulaDefinition, PanelDisplay, QueryOptionsDefinition } from './schema/utils';

export interface PanelDefinition<PluginSpec = UnknownSpec> extends Definition<PanelSpec<PluginSpec>> {
  kind: 'Panel';
}

export interface PanelSpec<PluginSpec> {
  display: PanelDisplay;
  plugin: Definition<PluginSpec>;
  queries?: QueryDefinition[];
  query_options?: QueryOptionsDefinition;
  formulas?: FormulaDefinition[];
  links?: ContextLinkDefinition[];
}

export enum PanelSettingsType {
  ADVANCED = 'advanced',
  GENERAL = 'general',
}
